import { useEffect, useRef } from 'react';
import { useCartStore } from '../../store/useCartStore';
import { useCartItemActions } from './useCartItemActions';
import type { CartItem } from '../../types/cartTypes';

export function useCartLineItem(lineRef: string) {
  const item = useCartStore((s) => s.itemsByLineRef[lineRef]);
  const currency = useCartStore((s) => s.currency || 'EUR');
  const lastItemRef = useRef<CartItem | null>(null);

  useEffect(() => {
    if (item) {
      lastItemRef.current = item;
    }
  }, [item]);

  const resolvedItem = item ?? lastItemRef.current;
  const currentQty = resolvedItem?.quantity ?? 0;

  const { remove, updatingType } = useCartItemActions(lineRef, currentQty);

  return {
    item: resolvedItem,
    currency,
    onRemove: remove,
    updatingType
  };
}
